/**
 * TornPaperCard — card with jagged torn-paper top edge
 */

import { ReactNode } from 'react';

interface TornPaperCardProps {
  children: ReactNode;
  className?: string;
}

export default function TornPaperCard({
  children,
  className = '',
}: TornPaperCardProps) {
  return (
    <div className={`relative ${className}`}>
      {/* Torn top edge */}
      <svg
        viewBox="0 0 400 16"
        preserveAspectRatio="none"
        className="w-full block pointer-events-none"
        style={{ height: 16, marginBottom: -1 }}
      >
        <path
          d="M0,16 L0,8 L12,6 L28,10 L44,4 L62,9 L80,5 L96,11 L114,3 L132,8 L150,5 L168,10 L186,4 L204,9 L222,6 L240,11 L258,3 L276,8 L294,5 L312,10 L330,4 L348,9 L366,6 L384,10 L400,7 L400,16 Z"
          fill="var(--kid-surface)"
        />
      </svg>
      {/* Card body */}
      <div className="bg-kid-surface p-5 shadow-kid border-x-2 border-b-2 border-kid-ocean/10 rounded-b-kid">
        {children}
      </div>
    </div>
  );
}
